module.exports = __webpack_public_path__ + "static/media/ideate_ie.da6b2be5.png";